import React from 'react';
import _ from 'lodash';
import { Stack, FormControl, Typography, Box, Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { DebounceInput } from 'react-debounce-input';
import { CssTextField } from '../../../../../components/others/CssTextField';

const Row = props => {
  const { numRow, formik } = props;
  const [value, setValue] = React.useState('');

  const onChange = val => {
    setValue(val);
    const fieldClone = _.cloneDeep(formik.values.gross_values_per_number_of_friends);
    fieldClone[numRow] = val;
    formik.setFieldValue('gross_values_per_number_of_friends', fieldClone);
  };

  React.useEffect(() => {
    setValue(formik.values.gross_values_per_number_of_friends[numRow]);
  }, [formik.values.gross_values_per_number_of_friends]);

  return (
    <FormControl fullWidth >
      <Stack direction="row" alignItems="center" justifyContent="center">
        <DebounceInput
          style={{ margin: 3 }}
          debounceTimeout={500}
          element={CssTextField}
          value={numRow + 1}
          onChange={e => onChange(e.target.value)}
          variant="outlined"
          label="liczba znajomych"
          disabled
        />
        <DebounceInput
          style={{ margin: 3 }}
          debounceTimeout={500}
          element={CssTextField}
          label="wartość brutto (zł)"
          value={value}
          onChange={e => onChange(e.target.value)}
          variant="outlined"
        />
      </Stack>

    </FormControl>
  );
};

export const MultiFriendsTable = props => {
  const { formik } = props;
  const [numRows, setNumRows] = React.useState(1);

  const onAdd = () => {
    setNumRows(numRows + 1);
    formik.setFieldValue('gross_values_per_number_of_friends', [...formik.values.gross_values_per_number_of_friends, '']);
  };

  const onRemove = () => {
    if (formik.values.gross_values_per_number_of_friends.length > 0) {
      setNumRows(numRows - 1);
      formik.setFieldValue('gross_values_per_number_of_friends', formik.values.gross_values_per_number_of_friends.splice(0, formik.values.gross_values_per_number_of_friends.length - 1));
    }
  };

  React.useEffect(() => {
    setNumRows(formik.values.gross_values_per_number_of_friends.length);
  }, [formik.values.gross_values_per_number_of_friends]);

  return (
    <Stack direction="column">
      <Box display="flex" justifyContent="center" direction="row" alignItems="center">
        <Fab
          sx={{ mr: 2 }}
          color="primary"
          aria-label="add"
          onClick={onAdd}
        >
          <AddIcon style={{ fontSize: '30px' }} />
        </Fab>
        <Typography color="primary" variant="h5">Dodaj znajomego</Typography>
        <Fab
          sx={{ ml: 2 }}
          color="primary"
          aria-label="add"
          onClick={onRemove}
        >
          <RemoveIcon style={{ fontSize: '30px' }} />
        </Fab>
      </Box>
      { _.map([...Array(numRows)], (key, numRow) => <Row numRow={numRow} key={key} formik={formik} />
      )}
    </Stack>
  );
};
